import { z } from "zod";

export const emailTemplateSchema = z.object({
  id: z.string().trim().optional(),
  name: z
    .string()
    .trim()
    .nonempty("El nombre de la plantilla es requerido")
    .max(255, "Máximo 255 caracteres"),
  description: z
    .string()
    .trim()
    .max(1000, "Máximo 1000 caracteres")
    .optional()
    .prefault(""),
});

export type EmailTemplateFormData = z.infer<typeof emailTemplateSchema>;
